import React, { useState } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';

const BillsAddButton = ({ setIsCollapsed, isCollapsed, t }) => {
  return (
    <div className="row">
      <Form.Button
        onClick={(e) => {
          e.preventDefault();
          setIsCollapsed(!isCollapsed);
        }}
        extraClassName="col-g btn btn-info ml-4 mr-4"
        text={`${
          isCollapsed
            ? t('acl.assetsBills.showForm')
            : t('acl.assetsBills.hideForm')
        }`}
      />
    </div>
  );
};

export default translate()(BillsAddButton);


// WEBPACK FOOTER //
// src/components/assets/form_sections/BillsAddButton.js